export default class FollowBtn {
    constructor() {
        this.hoverBtn();
    }

    hoverBtn() {
        const hoverBtns = document.querySelectorAll(".js-hover-follow");
        if (hoverBtns.length === 0) return;

        hoverBtns.forEach((button) => {
            button.addEventListener("mousemove", (e) => {
                const rect = button.getBoundingClientRect();
                const x = (e.clientX - (rect.left + rect.width / 2)) * 0.2;
                const y = (e.clientY - (rect.top + rect.height / 2)) * 0.2;
                button.style.transform = `translate(${x}px, ${y}px)`;
            });

            button.addEventListener("mouseleave", () => {
                button.style.transform = "translate(0, 0)";
            });
        });
    }
}